export default "__VITE_ASSET__CeZ49O_K__"